<template>
  <pbc-modal :disable-title='true' :full-height="false">

    <template #default='{}'>
      <div class="w-full bg-gray-800 bg-no-repeat" style="
                  background-blend-mode: multiply;
                  background-position: center center;
                  background-size: contain;
                  background-image: url('/img/PBC_Meme.svg');
                  ">
        <div class="p-10 py-12 flex flex-col flex-wrap justify-center content-center">
          <div class="z-60 mt-4">
            <h1 class="text-white font-bold text-2xl mb-2">Stay up to date</h1>
            <h1 class="text-white text-xl">Enable notifications to</h1>
            <h2 class="text-blue-300 font-bold text-2xl -mt-3">stay up to date</h2>
          </div>
        </div>

        </div>
    </template>

    <template #controls='{}'>
      <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500">
        <pbc-button @click='$emit("close")'>
          <close class="mx-2"/>
          <span class="mr-2">Not now</span>
        </pbc-button>
        <pbc-button class="text-white bg-blue-400" @click='$emit("add")'>
          <plus-circle-outline class="mx-2"/>
          <span class="mr-2">Enable</span>
        </pbc-button>
      </div>
    </template>
  </pbc-modal>

</template>
<script>
import PlusCircleOutline from '@icons/PlusCircleOutline.vue';
import Close from '@icons/Close.vue';
export default {
  data() {
    return {
    }
  },
  components:{
    PlusCircleOutline,
    Close,
  },
  mounted() {
    this.$ana.track({
      eventCategory: 'install',
      eventAction: 'dialogOpen'
    });
  },
  beforeDestroy() {
    this.$ana.track({
      eventCategory: 'install',
      eventAction: 'dialogClose'
    });
  },
  methods: {
  },
  watch: {
  }
}
</script>
